import { createMigration } from './utils';

export function getAspectRatioForResolution(width: number, height: number) {
    if (width === 1920 && height === 1080) {
        return 'landscape';
    }
    if (width === 1080 && height === 1920) {
        return 'vertical';
    }
    if (width === 1080 && height === 1080) {
        return 'square';
    }
    throw new Error(`Unknown width/height: ${width}/${height}`);
}

export const migrationTo9_175 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
            const template = map.get('template');
            map.set('template', this.migrateTemplate(template));
        });
    },
    migrateTemplate(template) {
        return template;
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup;
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            const width = map.getIn(['resolution', 'width']) as number;
            const height = map.getIn(['resolution', 'height']) as number;
            const aspectRatio = getAspectRatioForResolution(width, height);
            map.delete('resolution');
            map.set('aspectRatio', aspectRatio);
        });
    },
});
